export const SELECT_GEOGRAPHICS_TAB_OPTIONS = [
  { index: 0, value: 'censusRegion', label: 'Census Region' },
  { index: 1, value: 'state', label: 'State' },
  { index: 2, value: 'market', label: 'Market' },
  { index: 3, value: 'county', label: 'County' },
  { index: 4, value: 'zipcode', label: 'Zip Code' },
];
export const GEO_MAP_MODULE = 'geo';
export const SELECT_GEOGRAPHICS_LABEL = 'Select Geographies';

export const MAP_COLOR_CLASSES = {
  3: ['id1', 'id9', 'id3'],
  5: ['id1', 'id2', 'id4', 'id5', 'id7'],
  7: ['id1', 'id10', 'id11', 'id12', 'id13', 'id6', 'id8'],
};

export const GEO_HEAT_MAP_MESSAGE = {
  noTableData: 'A data table has not yet been generated for -1-.  Return to Table View to create the tabulated table.'
}

export const GEOGRAPHICS_TOP_NODE_VALUES = [
  { censusRegion: 100000 },
  { state: 200000 },
  { market: 300000 },
  { countyByMarket: 400000 },
  { countyByState: 500000 },
  { zipcodeByMarket: 600000 },
  { zipcodeByState: 700000 },
];

export const GEMOGRAPHICS_COUNTY_DROPDOWN_OPTIONS = [
  { value: 'countyByMarket', label: 'By Market' },
  { value: 'countyByState', label: 'By State' },
];

export const GEMOGRAPHICS_ZIPCODE_DROPDOWN_OPTIONS = [
  { value: 'zipcodeByMarket', label: 'By Market' },
  { value: 'zipcodeByState', label: 'By State' },
];

export const INITIAL_SELECTED_NODE_STATE = {
  county: [],
  censusRegion: [],
  state: [],
  market: [],
  zipcode: [],
};

export const INITIAL_GEOGRAPHIES_COUNT = {
  county: 0,
  censusRegion: 0,
  state: 0,
  market: 0,
  zipcode: 0,
};

// More work is needed around the upper limit
export const OVER_SCAN_ROW_COUNT = 20;

export const STUDY_CHANGE_INVALID_POPUP_LABELS = [
  { value: 'target', label: 'Target', selectedTab: 'target' },
  { value: 'base', label: 'Base', selectedTab: 'base' },
  {
    value: 'censusRegion',
    label: 'Census Region',
    selectedTab: 'censusRegion',
  },
  { value: 'state', label: 'State', selectedTab: 'state' },
  { value: 'market', label: 'Market', selectedTab: 'market' },
  { value: 'county', label: 'County', selectedTab: 'county' },
  { value: 'zipcode', label: 'Zip Code', selectedTab: 'zipcode' },
  {
    value: 'targetAndBase',
    label: 'Invalid Target And Base Combination',
    selectedTab: 'targetAndBase',
  },
];

export const GEOGRAPHICS_TOP_NODE_VALUES_ON_STUDY_CHANGE = [
  { censusRegion: 100000 },
  { state: 200000 },
  { market: 300000 },
  { county: 400000 },
  { zipcode: 700000 },
];

export const STUDY_CHANGE_POPUP_HEADING =
  'The following items are not available in the study you’ve just selected.';
export const STUDY_CHANGE_POPUP_SECOND_HEADING =
  'Click OK to proceed, but note that the data point(s) below will be removed.';
export const GEOMAP_MODULE_NO_STUDIES_ERROR_MSG =
  'You are not currently subscribed to the studies required for the Geo Mapping application. Please contact your Account Manager for more information.';
export const GEOMAPPING_BREADCRUMB = 'Geo Mapping';
export const PARENT_MODULE = 'Essentials / ';
export const GEOMAP_EXPORT_WARNING_MSG =
  'Larger files can take up to 3 minutes to export.';

export const GEO_MAP_VIEW = 'HEAT MAP';
export const TABLE_MAP_VIEW = 'TABLE VIEW';
export const LABLE_VIEW = 'View';
export const MATCH_VIEW = ['Census Region', 'State'];
